<script>
import appConfig from "@/app.config";
import {required, email} from "vuelidate/lib/validators";
import Vue from "vue";

/**
 * Login component
 */
export default {
  page: {
    title: "Đăng nhập",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
  },
  data() {
    return {
      email: null,
      password: null,
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      capcha: null,
      modelAuth: {
        isAuthError: false,
        message: null
      },
      model: {
        userName: "",
        password: ""
      },
      cssProps: {
        backgroundImage: `url(${require('./bgimg.jpg')})`
      },
      passwordFieldType: "password",
    };
  },
  validations: {
    model: {
      userName: {
        required,
      },
      password: {
        required
      }
    }
  },
  computed: {
    showPassword() {
      return this.passwordFieldType === "text";
    }
  },
  created() {

  },
  methods: {
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
    },

    async Login(e) {
      e.preventDefault();
      // if (!this.capcha && process.env.VUE_APP_ENV != 'development') {
      //   this.modelAuth.isAuthError = true;
      //   this.modelAuth.message = "Xác nhận đã nhập mã captcha";
      //   return;
      // }
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
       await this.$store.dispatch("authStore/login", this.model).then(async (res) => {

          if (res.code === 0) {

            // console.log("LOG NGUYEN TUAN KIET ", res)
            await new Promise(resolve => setTimeout(resolve, 1000));
            localStorage.setItem('auth-user', JSON.stringify(res.data));
            localStorage.setItem("user-token", JSON.stringify(res.data.accessToken));
            if (res.data) {
              if (res.data.menu) {
                localStorage.setItem("menuItems", JSON.stringify(res.data.menu));
              }
            }
            Vue.prototype.$auth_token = res.data.token;
            this.showModal = false;
            this.model = {};
            this.modelAuth.isAuthError = false;
            window.location.href = '/admin/tai-khoan'
          } else {
            if (res.Code == 24) {
              this.modelAuth.isAuthError = true;
              this.modelAuth.message = "Lỗi! Hãy kiểm tra kết nối mạng!";
            } else {
              this.modelAuth.isAuthError = true;
              console.log("LOG message : ", res.message)
              this.modelAuth.message = res.message;
            }
            loader.hide();
          }

        })
            .finally(() => {
              loader.hide();
            });
       }
       this.submitted = false;
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  },
  mounted() {
  },
};
</script>

<template>
  <div class="container-fluid p-0 bg-login">
    <div class="row g-12 justify-content-center">
      <div class="col-xl-4 col-md-6 col-12 login-box align-self-center">
        <div class="auth-full-page-content p-4">
          <div class="w-100">
            <div class="d-flex flex-column h-100">
              <div class="d-flex justify-content-center flex-column align-items-center">
              </div>
              <div class="my-auto">
                <div
                    class="text-center h6
                    text-uppercase fw-bold login-title"
                >
                  ĐĂNG NHẬP
                </div>
                <b-alert
                    v-model="modelAuth.isAuthError"
                    variant="danger"
                    class="mt-4"
                    dismissible
                >{{ modelAuth.message }}
                </b-alert
                >
                <b-form class="" @submit.prevent="Login" ref="formContainer">
                  <b-form-group
                      class="mb-4 title-form"
                      id="input-group-1"
                      label="Tài khoản"
                      label-for="input-1"
                  >
                    <b-form-input
                        id="input-1"
                        v-model="model.userName"
                        type="text"
                        placeholder="Nhập tài khoản"
                        :class="{ 'is-invalid': submitted && $v.model.userName.$error }"
                    ></b-form-input>
                    <div
                        v-if="submitted && $v.model.userName.$error"
                        class="invalid-feedback"
                    >
                      <span v-if="!$v.model.userName.required">Tài khoản không được trống.</span>
                    </div>
                  </b-form-group>
<!--                  <b-form-group-->
<!--                      class="mb-4 title-form"-->
<!--                      id="input-group-2"-->
<!--                      label="Mật khẩu"-->
<!--                      label-for="input-2"-->
<!--                  >-->
<!--                    <b-form-input-->
<!--                        id="input-2"-->
<!--                        v-model="model.password"-->
<!--                        :type="showPassword ? 'text' : 'password'"-->
<!--                        placeholder="Nhập mật khẩu"-->
<!--                        :class="{ 'is-invalid': submitted && $v.model.password.$error }"-->
<!--                    ></b-form-input>-->
<!--                    <div-->
<!--                        v-if="submitted && !$v.model.password.required"-->
<!--                        class="invalid-feedback"-->
<!--                    >-->
<!--                      Mật khẩu không được trống.-->
<!--                    </div>-->
<!--                  </b-form-group>-->

                  <template>
                    <b-form-group
                        id="input-group-2"
                        label="Mật khẩu"
                        label-for="input-2"
                        class="mb-3"
                        label-class="form-label"
                    >
                      <div class="position-relative">
                        <b-form-input
                            id="input-2"
                            v-model="model.password"
                            :type="passwordFieldType"
                            placeholder="Nhập mật khẩu"
                            :class="{ 'is-invalid': submitted && $v.model.password.$error }"
                            class="password"
                        ></b-form-input>
                        <div
                            v-if="submitted && !$v.model.password.required"
                            class="invalid-feedback"
                        >
                          Mật khẩu không được trống.
                        </div>
                        <div class="input-group-prepend">
                          <a @click="switchVisibility">
                            <template v-if="!showPassword">
                              <i class="mdi mdi-eye mdi-16px"></i>
                            </template>
                            <template v-else>
                              <i class="mdi mdi-eye-off mdi-16px"></i>
                            </template>
                            <!-- <template >
                              <i class="mdi mdi-eye-off mdi-16px"></i>
                            </template> -->
                          </a>
                        </div>
                      </div>

                    </b-form-group>
                  </template>
                  <div class="mt-3 d-grid">
                    <b-button
                        type="submit"
                        class="text-uppercase fw-bold login-submit"
                    >ĐĂNG NHẬP
                    </b-button
                    >
                  </div>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
  </div>
</template>

<style>
.bg-login {
  background: url("~@/assets/images/login-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 1;
}

.login-box {
  background-color: transparent;
  align-items: center;
  padding: 0 20px 0 20px !important;
  margin: 0 !important;
}

.login-title {                                                                                                                          
  font-size: 36px;
  background: -webkit-linear-gradient(0deg, #f8431f, #f49b00);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 20px;
}

.login-submit {
  margin: 20px 0 10px 0;
  color: #fff !important;
    background: -webkit-linear-gradient(0deg, #f8431f, #f49b00);
  border: none;
  font-size: 1.1rem;
}

.title-form,
.form-check-label,
.login-text {
  color: #2a2a2a;
  font-size: 1.1rem;
}


.form-label{
  font-size: 1.2rem;
  font-weight: normal;
}
.input-group-prepend {
  position: absolute;
  top: 17%;
  right: 13px;
  cursor: pointer;

}

</style>

